import cache from "./cache";
const translationsSimpleCache = cache();
const promiseWrapper = ({
  locale,
  id,
  promiseFn
}) => {
  const translationKey = `${id}-${locale}`;
  if (typeof window === "undefined") {
    const cachedTranslation = translationsSimpleCache.get(translationKey);
    if (cachedTranslation) {
      return cachedTranslation;
    }
  }
  const promise = promiseFn();
  let status = "pending";
  let error;
  let result;
  const suspender = promise.then((r) => {
    status = "success";
    result = r;
  }, (e) => {
    status = "error";
    error = e;
  });
  const value = {
    hydrated: false,
    read() {
      if (status === "pending") {
        throw suspender;
      } else if (status === "error") {
        throw error;
      }
      return result.default;
    }
  };
  if (typeof window === "undefined") {
    translationsSimpleCache.set(translationKey, value);
  }
  return value;
};
var promiseWrapper_default = promiseWrapper;
export {
  promiseWrapper_default as default
};
